import { FC } from 'react'
import styled from 'styled-components'

const H1 = styled.h1`
  font-size: 48px;
  margin: 0;
`

interface Props {
  title: string
}

const Title: FC<Props> = ({ title }) => {
  return <H1>{title}</H1>
}

export default Title
